//@flow
import { Grid } from "semantic-ui-react";
import React from "react";

export const FIRST_COLUMN = 6;
export const SECOND_COLUMN = 10;

export const FormRow = ({ titleComponent, children, rowStyles, ...otherProps }: any) => {
  const sideMargins = 2;
  return (
    <Grid.Row columns={5} style={rowStyles ? rowStyles : {}} {...otherProps}>
      <Grid.Column width={sideMargins - 1} />
      <Grid.Column verticalAlign={"middle"} width={FIRST_COLUMN - sideMargins + 1}>
        {titleComponent}
      </Grid.Column>
      <Grid.Column width={1} />
      <Grid.Column width={SECOND_COLUMN - sideMargins - 1}>{children}</Grid.Column>
      <Grid.Column width={sideMargins} />
    </Grid.Row>
  );
};
